<template>
    <div>
        <h1 class="display-heading">Invitation Module</h1>

        <p>Invite partners and users to join {{ companyName }} Platform!</p>

        <div class="card mb-3">
            <div class="card-header">Invite New Company</div>
            <div class="card-body">
                <p>Invite new companies to join {{ companyName }}!</p>
                <router-link class="btn btn-primary btn-primary-insv mr-2"
                    :to="{'name': 'admin-invite-company'}">
                    Invite New Company
                </router-link>

                <router-link class="btn btn-primary"
                    :to="{'name': 'admin-user-invitation-report', 'query': {'invitationType': 4}}">
                    View Invitation Report
                </router-link>
            </div>
        </div>
        <div class="card mb-3">
            <div class="card-header">Invite New Pharmacy</div>
            <div class="card-body">
                <p>Invite new pharmacies to become partner on {{ companyName }}!</p>
                <router-link class="btn btn-primary btn-primary-insv mr-2"
                    :to="{'name': 'admin-invite-pharmacy'}">
                    Invite New Pharmacy
                </router-link>

                <router-link class="btn btn-primary"
                    :to="{'name': 'admin-user-invitation-report', 'query': {'invitationType': 3}}">
                    View Invitation Report
                </router-link>
            </div>
        </div>
        <div class="card mb-3">
            <div class="card-header">Invite New Doctor</div>
            <div class="card-body">
                <p>Invite new doctors to become partner on {{ companyName }}!</p>
                <router-link class="btn btn-primary btn-primary-insv mr-2"
                    :to="{'name': 'admin-invite-doctor'}">
                    Invite New Doctor
                </router-link>

                <router-link class="btn btn-primary"
                    :to="{'name': 'admin-user-invitation-report', 'query': {'invitationType': 2}}">
                    View Invitation Report
                </router-link>
            </div>
        </div>
        <div class="card mb-3">
            <div class="card-header">Invite New Clinic</div>
            <div class="card-body">
                <p>Invite new clinics to become partner on {{ companyName }}!</p>
                <router-link class="btn btn-primary btn-primary-insv mr-2"
                    :to="{'name': 'admin-invite-clinic'}">
                    Invite New Clinic
                </router-link>

                <router-link class="btn btn-primary"
                    :to="{'name': 'admin-user-invitation-report', 'query': {'invitationType': 5}}">
                    View Invitation Report
                </router-link>
            </div>
        </div>
        <div class="card">
            <div class="card-header">Invite New Public User</div>
            <div class="card-body">
                <p>Invite public users to join {{ companyName }}!</p>
                <router-link class="btn btn-primary btn-primary-insv mr-2"
                    :to="{'name': 'admin-invite-user'}">
                    Invite New Users
                </router-link>

                <router-link class="btn btn-primary"
                    :to="{'name': 'admin-user-invitation-report', 'query': {'invitationType': 1}}">
                    View Invitation Report
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    'name': 'InvitationModule',
    'computed': {
        companyName () {
            return this.$store.state.operator.companyNameDisplay;
        }
    }
};

</script>
